<template>
	<button @click="acceptUnAccept" class="accept-button btn" :class="{btnGreen__ghost: accepted}"><span><span v-if="accepted" class="far fa-check-circle"></span> <span v-if="!accepted">Mark accepted</span> <span v-else>Accepted</span></span></button>
</template>


<script>
import api from './api'
export default {
	name: 'AcceptButton',
	data: function () {
		return {
			accepted: false
		};
	},
	props: ['isAccepted', 'answerId'],
	methods: {
		acceptUnAccept: function () {
			this.accepted ? this.unaccept() : this.accept();
		},
		accept: function () {
			api.accept(this.answerId)
				.then(this.setAccepted)
				.catch(this.handleRequestError);
		},
		unaccept: function () {
			api.unaccept(this.answerId)
				.then(this.setUnaccepted)
				.catch(this.handleRequestError);
		},
		setAccepted: function () {
			this.accepted = true;
			this.$eventHub.$emit('acceptedEvent', this.answerId);
		},
		setUnaccepted: function () {
			this.accepted = false;
			this.$eventHub.$emit('acceptedEvent', this.answerId);
		},
		handleOthersAccepted: function (answerId) {
			if (this.answerId === answerId) return;
			this.accepted = false;
		},
		handleRequestError: function (err) {
			this.$eventHub.$emit('addAlert', {
				type: 'error',
				message: 'Something went wrong'
			});
			Raygun && Raygun.send(err);
		}
	},
	mounted: function () {
		this.accepted = this.isAccepted;
		this.$eventHub.$on('acceptedEvent', this.handleOthersAccepted);
	}
}
</script>